import React from 'react'
import './index.css'
const TeamMember = props => {
    return ( 
            <div className="col-sm-3 mb-4">
                <div className='mainblockimg' onClick={()=>props.url && window.open(props.url, '_blank')}>
                    <img className="image" src={props.image} alt="Avatar"  />
                    <div className="overlay5">
                        <div className="text">{props.name}<br/><span className='designation'>{props.desi}</span></div>
                    </div>
                </div>
            </div> 
    )
}

  const TABS = [
    { id: "ALL", label: "All" },
    { id: "GLOBAL", label: "Global Team" }
  ];

const OurTeam = props => {
    const orderedTabs = [
        ...TABS.filter(tab => tab.id === props.detectedRegion),
        ...TABS.filter(tab => tab.id !== props.detectedRegion),
    ];
    return (
        <div className="row ourTeam mt-5 pl-5 pr-5 mr-0 ml-0">            
            <div className="ourTeamOuter">
                <div className="ourTeamContainer">
                    <div className="teamHeader text-center w-100 mb-2">
                        <h2 className="teamTitle">Meet the Team</h2>
                        <div className="teamDivider"></div>
                    </div>  
                    <div className="teamTabsWrapper">
                        <div className="teamTabs">
                            {orderedTabs.map(tab => (
                                <button
                                    key={tab.id}
                                    className={`tabBtn ${props.activeTab === tab.id ? "active" : ""}`}
                                    onClick={() => props.handleTabChange(tab.id)}
                                >
                                    {tab.label}
                                </button>
                            ))}
                            {/* <div  className={`tabIndicator ${props.activeTab === TABS[1].id ? "right" : "left"}`}/>                       */}
                        </div>
                    </div>
                </div>
            </div>
            {props.teamMembers.map(teamMember => <TeamMember key={teamMember.name} url={teamMember.url} image={teamMember.image} name={teamMember.name} desi={teamMember.desi}/>)}
        </div>
    )
};

export default OurTeam;